<template>
	<div class="simple-search">
		<base-dialog v-model="showInplaceWithoutLocationDialog" centered :okFn="doSearch" :cancelFn="() => showInplaceWithoutLocationDialog = false">
			<p class="text-center">{{ $t('simple-search.inplace-without-location-warning') }}</p>
		</base-dialog>
		<base-dialog v-model="showNoLocationsDialog" :okFn="() => { $router.push(`/patient/search?profId=${this.searchForm.multipleSearch.professional}`) }" :cancelFn="() => showNoLocationsDialog = false" centered>
			<p class="text-center">{{ $t('simple-search.no-locations-dialog-warning') }}</p>
		</base-dialog>
		<!-- Menú de selección entre servicios o consulta -->
		 <div class="mb-3" v-if="!search360">
			<base-button class="btn-landing" :outline="!inPersonVisitSearchVisible" icon="/static-appopensalud/img/icons/morillas-svg-icons/primary/ICN_OUT_CONSULTA_CASA.svg" :iconColor="inPersonVisitSearchVisible ? WHITE_COLOUR : BLUE_COLOUR" @click="toggleInPersonVisitSearch" noHoverStyles>
				{{ $t('simple-search.in-person-visit') }}
			</base-button>
			<base-button class="btn-landing ml-2" :outline="!onlineSearchVisible" icon="/static-appopensalud/img/icons/morillas-svg-icons/primary/ICN_OUT_VIDEOCONSULTA.svg" :iconColor="onlineSearchVisible ? WHITE_COLOUR : BLUE_COLOUR" @click="toggleOnlineSearch" noHoverStyles>{{ $t('simple-search.online') }}</base-button>
		</div>

		<div v-if="anySearchVisible">
			<transition-group name="fade" tag="div" class="seeker-row" mode="out-in">
				<b-col xs="12" sm="12" md="12" key="multiple-search-selector">
					<MultipleSearchSelector :key="multipleSearchSelectorKey" v-model="searchForm.multipleSearch" @option:selected="onMultipleSearchInput" :includeServices="inPersonVisitSearchVisible" :only360Specialties="search360" :appointmentType="inPersonVisitSearchVisible ? INPLACE : null"/>
				</b-col>
				<b-col xs="12" sm="12" md="12" v-if="inPersonVisitSearchVisible" key="location-selector">
					<base-select searchable clearable :options="formOptions.locations" valueProp="id" :label="$i18nHelpers.normalizeProp('name')" v-model="searchForm.location" @input="onLocationSelected" :placeholder="$t('simple-search.location')" :disabledText="locationSelectorIsDisabled ? $t('simple-search.select-specialty-or-service') : null" :loading="false"></base-select>
				</b-col>
				<b-col xs="12" sm="12" md="12" v-if="inPersonVisitSearchVisible" key="consultation-type-selector">
					<base-select :options="inPersonConsultationTypes" valueProp="id" label="name" v-model="searchForm.inPersonConsultationType" :disabled="inPersonConsultationTypes.length === 1"></base-select>
				</b-col>
				<b-col class="align-items-center" style="justify-content: space-between;" xs="12" sm="12" md="12" key="search-button">
					<base-button blue @click="doSearch" class="w-100">
						<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/search.svg" color="white" />
						<span class="ml-2">{{ $t('search') }}</span>
					</base-button>
				</b-col>
			</transition-group>
		</div>
	</div>
</template>

<script>
import geographyRepository from '@/repositories/GeographyRepository'
import insurersRepository from '@/repositories/InsurersRepository'
import { INPLACE, VIDEO } from '@/constants/consultationTypes'
import MultipleSearchSelector from '@/components/shared/MultipleSearchSelector'
import i18nMixin from '@/mixins/i18n.mixin'
import { WHITE_COLOUR, BLUE_COLOUR } from '@/constants/colours'
import BaseDialog from '@/components/base/BaseDialog'
const PRIVATE_CONSULTATION_TYPE = 'private'
const INSURANCE_CONSULTATION_TYPE = 'insurance'
const I18N_FILE = 'public/simple-search'

export default {
	components: {
		MultipleSearchSelector,
		BaseDialog
	},
	props: {
		// If true, the search will be only for 360
		search360: {
			type: Boolean,
			default: false
		}
	},
	mixins: [i18nMixin(I18N_FILE)],
	created () {
		if (this.search360) {
			this.toggleOnlineSearch()
		}
	},
	data () {
		return {
			inPersonVisitSearchVisible: true,
			onlineSearchVisible: false,
			searchForm: {
				// Could be 'specialty', 'user' or 'medical exam'
				multipleSearch: null,
				inPersonConsultationType: PRIVATE_CONSULTATION_TYPE,
				location: null
			},
			formOptions: {
				locations: []
			},
			availableInsurers: [],
			WHITE_COLOUR,
			BLUE_COLOUR,
			showInplaceWithoutLocationDialog: false,
			multipleSelectorKeyNumber: 1,
			showNoLocationsDialog: false,
			INPLACE,
			VIDEO
		}
	},
	methods: {
		resetMultipleSearch () {
			// Preserve the selected specialty or professional
			this.searchForm.multipleSearch = {
				specialty: this.searchForm.multipleSearch ? this.searchForm.multipleSearch.specialty : null,
				professional: this.searchForm.multipleSearch ? this.searchForm.multipleSearch.professional : null,
				service: null
			}
		},
		toggleInPersonVisitSearch () {
			this.resetMultipleSearch()
			this.inPersonVisitSearchVisible = true
			this.onlineSearchVisible = false
		},
		toggleOnlineSearch () {
			this.resetMultipleSearch()
			this.inPersonVisitSearchVisible = false
			this.onlineSearchVisible = true
			this.searchForm.location = null
		},
		loadCities () {
			if (this.formOptions.locations && this.formOptions.locations > 0) {
				return
			}
			geographyRepository.getStates(this.requestParams).then(response => {
				this.formOptions.locations = response.data
				if (this.searchForm.multipleSearch && this.searchForm.multipleSearch.professional && this.formOptions.locations.length === 0) {
					this.showNoLocationsDialog = true
				}
			})
		},
		checkAvailableInsurances () {
			insurersRepository.getInsurers(this.requestParams).then((response) => {
				this.availableInsurers = response.data || []
			})
		},
		onMultipleSearchInput () {
			if (this.inPersonVisitSearchVisible) {
				this.loadCities()
				this.checkAvailableInsurances()
			}
		},
		onLocationSelected () {
			this.checkAvailableInsurances()
		},
		doSearch () {
			if (!this.searchForm.multipleSearch || (!this.searchForm.multipleSearch.specialty && !this.searchForm.multipleSearch.professional && !this.searchForm.multipleSearch.service)) {
				this.$store.dispatch('showAlert', {
					text: this.$t('simple-search.select-specialty-professional-or-service'),
					variant: 'info'
				})
				return
			}

			// Show info message when user is in inplace search but didn't select a location
			if (!this.searchForm.multipleSearch.professional && this.inPersonVisitSearchVisible && !this.searchForm.location) {
				// this.$store.dispatch('showAlert', {
				// 	text: this.$t('simple-search.select-location'),
				// 	variant: 'info'
				// })
				this.$store.dispatch('showSharedDialog', { content: this.$t('simple-search.select-location') })
				return
			}

			let queryParams = ''
			if (this.searchForm.multipleSearch.specialty) {
				queryParams += `specialty=${this.searchForm.multipleSearch.specialty}`
			} else if (this.searchForm.multipleSearch.professional) {
				queryParams += `profId=${this.searchForm.multipleSearch.professional}`
			} else if (this.searchForm.multipleSearch.service) {
				queryParams += `service=${this.searchForm.multipleSearch.service}`
			}

			if (this.searchForm.location) {
				queryParams += `&location=${this.searchForm.location}`
			}

			if (this.inPersonVisitSearchVisible && (this.searchForm.multipleSearch.specialty || this.searchForm.multipleSearch.professional)) {
				queryParams += `&appointmentType=${INPLACE}`
			} else if (this.inPersonVisitSearchVisible && this.searchForm.multipleSearch.service) {
				queryParams += `&service=${this.searchForm.multipleSearch.service}`
			}

			if (this.inPersonVisitSearchVisible && this.searchForm.inPersonConsultationType === INSURANCE_CONSULTATION_TYPE) {
				queryParams += `&anyInsurer=1`
			}

			let searchUrl = `/patient/search?${queryParams}`
			this.$router.push(searchUrl)
		}
	},
	computed: {
		inPersonConsultationTypes () {
			let options = [
				{ id: PRIVATE_CONSULTATION_TYPE, name: this.$t('simple-search.private-appointment') }
			]
			if (!this.searchForm.multipleSearch || this.availableInsurers.length > 0) {
				options.push({ id: INSURANCE_CONSULTATION_TYPE, name: this.$t('simple-search.insurance-appointment') })
			} else {
				this.searchForm.inPersonConsultationType = PRIVATE_CONSULTATION_TYPE
			}
			return options
		},
		requestParams () {
			return {
				...this.searchForm.multipleSearch,
				appointmentType: this.inPersonVisitSearchVisible ? INPLACE : null,
				location: this.searchForm.location,
				withProfessionals: true
				// withCenters: true TODO: enable when showing centers and professionals in same search
			}
		},
		anySearchVisible () {
			return this.inPersonVisitSearchVisible || this.onlineSearchVisible
		},
		locationSelectorIsDisabled () {
			return this.inPersonVisitSearchVisible && (!this.formOptions.locations || this.formOptions.locations.length === 0)
		},
		multipleSearchSelectorKey () {
			return `multiple-search-selector-${this.multipleSelectorKeyNumber}`
		}
	}
}
</script>

<style scoped lang="scss">
.simple-search {
	background-color: rgba(255, 255, 255, 0.5);
	box-shadow: $custom-shadow;
	padding: 1rem;
	border-radius: $border-radius;
}

.seeker-row {
	> div:not(:last-child) {
		margin-bottom: 1rem;
	}
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
}
.fade-move {
  transition: transform 0.5s ease;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/SimpleSearch.vue